export function domExist ( elm ) {
  return ( elm !== null ) ? true : false;
}
